var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontalKebab = function SvgHorizontalKebab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.192 11.25q-.515 0-.882-.367A1.2 1.2 0 0 1 3.942 10q0-.516.368-.883.367-.367.882-.367.516 0 .883.367.367.368.367.883 0 .516-.367.883t-.883.367m4.808 0q-.516 0-.883-.367A1.2 1.2 0 0 1 8.75 10q0-.516.367-.883.368-.367.883-.367.516 0 .883.367.367.368.367.883 0 .516-.367.883a1.2 1.2 0 0 1-.883.367m4.808 0q-.516 0-.883-.367a1.2 1.2 0 0 1-.367-.883q0-.516.367-.883.368-.367.883-.367.516 0 .883.367.366.368.367.883 0 .516-.367.883a1.2 1.2 0 0 1-.883.367"
  })));
};
export default SvgHorizontalKebab;